export const nullMiddleware = _store => next => action => next(action)
